module.exports = __webpack_public_path__ + "static/media/EmiliaSalvioni.08df0f11.jpg";